import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
import lastDayOfYear from "date-fns/lastDayOfYear";
import startOfYear from "date-fns/startOfYear";

const GetAllAgents = async (
  Year = "*",
  Filter = "newest",
  lastSnapshot = "*",
  LimitCount = 10
) => {
  /**
   * input: null
   * output: agents object
   * description: fetches all agents
   */
  try {
    let firstDay;
    let lastDay;
    if (Year === "*") {
      firstDay = startOfYear(new Date().setFullYear(2000));
      lastDay = lastDayOfYear(new Date());
    } else {
      lastDay = lastDayOfYear(new Date(Year));
      firstDay = startOfYear(new Date(Year));
    }

    let agentCollection = collection(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents"
    );

    let q;
    if (Filter === "newest") {
      q = query(
        agentCollection,
        where("is_deleted", "==", false),
        where("createdAt", ">", firstDay),
        where("createdAt", "<", lastDay),
        orderBy("createdAt", "desc"),
        startAfter(lastSnapshot),
        limit(LimitCount)
      );
    } else {
      q = query(
        agentCollection,
        where("is_deleted", "==", false),
        where("createdAt", ">", firstDay),
        where("createdAt", "<", lastDay),
        orderBy("createdAt"),
        limit(LimitCount)
      );
    }

    // Query the first page of docs
    const agentsSnapshot = await getDocs(q);

    let agents = [];
    agentsSnapshot.forEach((agent) =>
      agents.push({ id: agent.id, ...agent.data() })
    );

    return {
      agents,
      agentsSnapshot,
    };
  } catch (error) {
    console.log(error);
  }
};

export default GetAllAgents;
